import { MaterialMatcher } from './material-matcher'

export class BomMatcher {
  public materialMatcher: MaterialMatcher = new MaterialMatcher()

  public allowedNames: string[] = []
}
